import { SummaryTile } from './SummaryTile';
import styles from './SummaryTiles.module.scss';

/**
 * Props:
 *   header    node above the tiles inside the card — a sub-tab strip, where a tab has one
 *   tiles     Array<{ label, value, info? }> — omit for a plain card, as the empty state uses
 *   children  the tab's own content, usually a Table
 */
export const SummaryTiles = ({ header, tiles = [], children }) => (
  <div className={styles.card}>
    {header && <div className={styles.header}>{header}</div>}
    {tiles.length > 0 && (
      <div className={styles.summaryRow}>
        {tiles.map(({ label, value, info }) => (
          <SummaryTile
            key={label}
            label={label}
            value={value}
            info={info}
            className={styles.joinedTile}
          />
        ))}
      </div>
    )}
    {children}
  </div>
);
